/*
 * Heldenglueck B2B - Mengenauswahl auf der Produktseite. 03.09.2026, Fassung 4
 *
 * Schnellwahl in Verkaufseinheiten plus freies Mengenfeld.
 * Obergrenze nur der Lagerbestand. Preise nur fuer eingeloggte Haendler
 * (window.hgKunde aus snippets/cart-drawer.liquid).
 */

(function () {
  var VE_RULES = [
    { tag: 'VE-4', step: 4 },
    { tag: 'VE-10', step: 10 },
    { tag: 'VE-12', step: 12 },
    { tag: 'VE-24', step: 24 }
  ]

  var STUFEN = 5
  var produkt = null
  var regel = null

  var STUECK = 'St\u00fcck'

  function kunde() {
    return window.hgKunde === true
  }

  function euro(cents) {
    var betrag = (cents / 100).toFixed(2)
    var teile = betrag.split('.')
    teile[0] = teile[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    return teile.join(',') + '\u00a0\u20ac'
  }

  function regelAusTags(tags) {
    if (!tags) return null
    for (var i = 0; i < VE_RULES.length; i++) {
      if (tags.indexOf(VE_RULES[i].tag) !== -1) return VE_RULES[i]
    }
    return null
  }

  function aktiveVariante(form) {
    var feld = form.querySelector('[name="id"]')
    var id = feld ? parseInt(feld.value, 10) : null

    if (id) {
      for (var i = 0; i < produkt.variants.length; i++) {
        if (produkt.variants[i].id === id) return produkt.variants[i]
      }
    }

    for (var j = 0; j < produkt.variants.length; j++) {
      if (produkt.variants[j].available) return produkt.variants[j]
    }

    return produkt.variants[0]
  }

  function lager(variante) {
    var daten = window.hgBestaende ? window.hgBestaende[variante.id] : null
    if (!daten) return null
    if (!daten.verwaltet || daten.weiterverkauf) return null
    return Math.max(0, daten.menge)
  }

  function obergrenze(variante) {
    var bestand = lager(variante)
    if (bestand === null) return null
    return Math.floor(bestand / regel.step) * regel.step
  }

  function runden(menge, richtung) {
    if (menge <= 0) return regel.step
    var faktor = richtung < 0 ? Math.floor(menge / regel.step) : Math.ceil(menge / regel.step)
    var ziel = faktor * regel.step
    return ziel < regel.step ? regel.step : ziel
  }

  function css() {
    if (document.getElementById('hg-menge-css')) return

    var style = document.createElement('style')
    style.id = 'hg-menge-css'
    style.textContent =
      '.hg-menge{margin:1.2rem 0 1.4rem;}' +
      '.hg-menge__kopf{display:flex;justify-content:space-between;align-items:baseline;gap:1rem;margin:0 0 .6rem;font-size:.9em;}' +
      '.hg-menge__label{font-weight:600;}' +
      '.hg-menge__lager{opacity:.6;}' +
      '.hg-menge__chips{display:flex;flex-wrap:wrap;gap:.5rem;margin:0 0 .8rem;}' +
      '.hg-menge__chip{flex:1 1 auto;min-width:3.4rem;padding:.55rem .8rem;border:1px solid rgba(0,0,0,.18);border-radius:999px;background:transparent;color:inherit;font:inherit;font-size:.92em;cursor:pointer;text-align:center;line-height:1.2;transition:all .15s;}' +
      '.hg-menge__chip:hover{border-color:currentColor;}' +
      '.hg-menge__chip[data-aktiv="1"]{background:currentColor;}' +
      '.hg-menge__chip[data-aktiv="1"] span{color:#fff;mix-blend-mode:difference;}' +
      '.hg-menge__chip[data-gesperrt="1"]{opacity:.35;cursor:not-allowed;text-decoration:line-through;}' +
      '.hg-menge__stepper{display:flex;align-items:stretch;border:1px solid rgba(0,0,0,.18);border-radius:8px;overflow:hidden;max-width:16rem;}' +
      '.hg-menge__btn{flex:0 0 2.8rem;border:0;background:transparent;color:inherit;font:inherit;font-size:1.25em;cursor:pointer;line-height:1;}' +
      '.hg-menge__btn:hover{background:rgba(0,0,0,.05);}' +
      '.hg-menge__btn:disabled{opacity:.3;cursor:not-allowed;}' +
      '.hg-menge__input{flex:1 1 auto;min-width:0;width:100%;border:0;border-left:1px solid rgba(0,0,0,.18);border-right:1px solid rgba(0,0,0,.18);background:transparent;color:inherit;font:inherit;text-align:center;padding:.6rem .4rem;-moz-appearance:textfield;}' +
      '.hg-menge__input::-webkit-outer-spin-button,.hg-menge__input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0;}' +
      '.hg-menge__summe{margin:.6rem 0 0;font-size:.95em;display:flex;justify-content:space-between;gap:1rem;}' +
      '.hg-menge__summe strong{font-weight:600;}' +
      '.hg-menge__hinweis{margin:.4rem 0 0;font-size:.85em;opacity:.65;}'

    document.head.appendChild(style)
  }

  function zustand(form) {
    return form.hgZustand
  }

  function mengeSetzen(form, menge, richtung) {
    var z = zustand(form)
    var variante = aktiveVariante(form)
    var grenze = obergrenze(variante)

    menge = runden(menge, richtung || 0)
    if (grenze !== null && menge > grenze) menge = grenze
    if (menge < regel.step && grenze !== null && grenze === 0) menge = 0

    z.menge = menge

    var feld = form.querySelector('input[name="quantity"]:not(.hg-menge__input)')
    if (!feld) {
      feld = document.createElement('input')
      feld.type = 'hidden'
      feld.name = 'quantity'
      form.appendChild(feld)
    }
    feld.value = menge
    feld.setAttribute('value', menge)
    if (feld.type !== 'hidden') feld.dispatchEvent(new Event('change', { bubbles: true }))

    z.input.value = menge

    Array.prototype.forEach.call(z.chips, function (chip) {
      var wert = parseInt(chip.dataset.menge, 10)
      chip.dataset.aktiv = wert === menge && chip.dataset.gesperrt !== '1' ? '1' : '0'
    })

    z.minus.disabled = menge <= regel.step
    z.plus.disabled = grenze !== null && menge + regel.step > grenze

    if (z.summe) {
      z.summe.innerHTML = '<span>' + menge + '\u00a0' + STUECK + ' \u00d7 ' + euro(variante.price) + '</span><strong>' + euro(variante.price * menge) + '</strong>'
    }
  }

  function grenzenAktualisieren(form) {
    var z = zustand(form)
    var variante = aktiveVariante(form)
    var grenze = obergrenze(variante)
    var bestand = lager(variante)

    Array.prototype.forEach.call(z.chips, function (chip) {
      var wert = parseInt(chip.dataset.menge, 10)
      var gesperrt = grenze !== null && wert > grenze
      chip.dataset.gesperrt = gesperrt ? '1' : '0'
      chip.title = gesperrt ? 'nicht in dieser Menge auf Lager' : ''
    })

    if (bestand === null) {
      z.lagerText.textContent = ''
    } else if (bestand === 0) {
      z.lagerText.textContent = 'zurzeit nicht auf Lager'
    } else {
      z.lagerText.textContent = 'auf Lager: ' + bestand + '\u00a0' + STUECK
    }

    z.input.max = grenze !== null ? grenze : ''
  }

  function auswahlBauen(form) {
    if (form.dataset.hgMenge === '1') return
    form.dataset.hgMenge = '1'

    var variante = aktiveVariante(form)
    if (!variante) return

    css()

    var box = document.createElement('div')
    box.className = 'hg-menge'

    var kopf = document.createElement('div')
    kopf.className = 'hg-menge__kopf'
    kopf.innerHTML = '<span class="hg-menge__label">Menge \u00b7 Verkaufseinheit ' + regel.step + '\u00a0' + STUECK + '</span><span class="hg-menge__lager"></span>'

    var chips = document.createElement('div')
    chips.className = 'hg-menge__chips'

    for (var i = 1; i <= STUFEN; i++) {
      var wert = regel.step * i
      var chip = document.createElement('button')
      chip.type = 'button'
      chip.className = 'hg-menge__chip'
      chip.dataset.menge = wert
      chip.innerHTML = '<span>' + wert + '</span>'
      chips.appendChild(chip)
    }

    var stepper = document.createElement('div')
    stepper.className = 'hg-menge__stepper'
    stepper.innerHTML =
      '<button type="button" class="hg-menge__btn" data-richtung="-1" aria-label="Menge verringern">\u2212</button>' +
      '<input class="hg-menge__input" type="number" inputmode="numeric" step="' + regel.step + '" min="' + regel.step + '" aria-label="Menge">' +
      '<button type="button" class="hg-menge__btn" data-richtung="1" aria-label="Menge erh\u00f6hen">+</button>'

    var summe = null
    if (kunde()) {
      summe = document.createElement('p')
      summe.className = 'hg-menge__summe'
    }

    var hinweis = document.createElement('p')
    hinweis.className = 'hg-menge__hinweis'
    hinweis.textContent = 'Frei w\u00e4hlbar in ' + regel.step + 'er-Schritten.' + (kunde() ? ' Preise netto.' : '')

    box.appendChild(kopf)
    box.appendChild(chips)
    box.appendChild(stepper)
    if (summe) box.appendChild(summe)
    box.appendChild(hinweis)

    var knopf = form.querySelector('[name="add"], button[type="submit"], input[type="submit"]')
    if (knopf && knopf.parentElement) {
      knopf.parentElement.insertBefore(box, knopf)
    } else {
      form.appendChild(box)
    }

    form.hgZustand = {
      menge: regel.step,
      chips: chips.querySelectorAll('.hg-menge__chip'),
      input: stepper.querySelector('.hg-menge__input'),
      minus: stepper.querySelector('[data-richtung="-1"]'),
      plus: stepper.querySelector('[data-richtung="1"]'),
      summe: summe,
      lagerText: kopf.querySelector('.hg-menge__lager')
    }

    var z = form.hgZustand

    chips.addEventListener('click', function (event) {
      var chip = event.target.closest('.hg-menge__chip')
      if (!chip || chip.dataset.gesperrt === '1') return
      event.preventDefault()
      mengeSetzen(form, parseInt(chip.dataset.menge, 10), 0)
    })

    z.minus.addEventListener('click', function (event) {
      event.preventDefault()
      mengeSetzen(form, z.menge - regel.step, -1)
    })

    z.plus.addEventListener('click', function (event) {
      event.preventDefault()
      mengeSetzen(form, z.menge + regel.step, 1)
    })

    z.input.addEventListener('change', function () {
      var wert = parseInt(z.input.value, 10)
      if (isNaN(wert)) wert = regel.step
      mengeSetzen(form, wert, wert < z.menge ? -1 : 1)
    })

    z.input.addEventListener('focus', function () {
      z.input.select()
    })

    z.input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault()
        z.input.blur()
      }
    })

    form.addEventListener('change', function (event) {
      if (event.target && event.target.classList && event.target.classList.contains('hg-menge__input')) return
      window.setTimeout(function () {
        grenzenAktualisieren(form)
        mengeSetzen(form, z.menge, 0)
      }, 50)
    })

    var vorhandenesFeld = form.querySelector('input[name="quantity"]:not(.hg-menge__input)')
    var start = vorhandenesFeld ? parseInt(vorhandenesFeld.value, 10) : regel.step
    if (isNaN(start) || start < regel.step) start = regel.step

    grenzenAktualisieren(form)
    mengeSetzen(form, start, 0)

    var alterWaehler = form.querySelector('quantity-selector')
    if (alterWaehler) alterWaehler.style.display = 'none'
  }

  function anwenden() {
    if (!regel) return
    Array.prototype.forEach.call(document.querySelectorAll('form[action*="/cart/add"]'), auswahlBauen)
  }

  function start() {
    var pfad = window.location.pathname
    if (pfad.indexOf('/products/') === -1) return

    fetch(pfad.split('?')[0] + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.ok ? r.json() : null
      })
      .then(function (daten) {
        if (!daten) return

        produkt = daten
        regel = regelAusTags(daten.tags)
        if (!regel) return

        anwenden()

        var wartet = false
        var beobachter = new MutationObserver(function () {
          if (wartet) return
          wartet = true
          window.requestAnimationFrame(function () {
            wartet = false
            anwenden()
          })
        })

        if (document.body) beobachter.observe(document.body, { childList: true, subtree: true })
      })
      .catch(function () {})
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start)
  } else {
    start()
  }
})()
